import downloadIcon from "../../images/icon_download.svg";
import PDFIcon from "../../images/icon_pdf.svg";
import { API } from "../../utils/api";
import { COUNTRIES, DEPARTMENTS } from "../../utils/complaintsConstants";
import { HTTP_METHODS } from "../../utils/constants";
import { dateToRegularFormat } from "../../utils/dates";
import { formatNumber } from "../../utils/numbers";
import {
  SectionTitle,
  Text,
} from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import {
  Container,
  DocumentContainer,
} from "./AdminComplaintsDetailComplaintStyles";

function AdminComplaintsDetailComplaint(props) {
  const { complaint } = props;
  const handleDownload = (objectName) => {
    generateDownloadUrl(objectName).then((url) => {
      window.open(url, "_blank");
    });
  };
  return (
    <Container>
      <div className="complaint-info">
        <div>
          <SectionTitle light={true}>NEGOCIO</SectionTitle>
          <Text small={true}>{complaint.business}</Text>
        </div>
        <div>
          <SectionTitle light={true}>FECHA</SectionTitle>
          <Text small={true}>
            {dateToRegularFormat(`${complaint.enterDate.split("T")[0]} 00:00`)}
          </Text>
        </div>
        <div>
          <SectionTitle light={true}>ÁREA</SectionTitle>
          <Text small={true}>{complaint.area}</Text>
        </div>
        <div>
          <SectionTitle light={true}>PROCESO</SectionTitle>
          <Text small={true}>{complaint.process}</Text>
        </div>
        <div>
          <SectionTitle light={true}>DOCUMENTO</SectionTitle>
          <Text small={true}>{complaint.document}</Text>
        </div>
        <div>
          <SectionTitle light={true}>No. DE DOCUMENTO</SectionTitle>
          <Text small={true}>{complaint.documentNumber}</Text>
        </div>
        <div>
          <SectionTitle light={true}>PAÍS</SectionTitle>
          <Text small={true}>
            {
              COUNTRIES.filter((country) => {
                return country.value === complaint.country;
              })[0].label
            }
          </Text>
        </div>
        <div>
          <SectionTitle light={true}>DEPARTAMENTO</SectionTitle>
          <Text small={true}>
            {
              DEPARTMENTS.filter((department) => {
                return department.value === complaint.region;
              })[0].label
            }
          </Text>
        </div>
        <div>
          <SectionTitle light={true}>MOTIVO</SectionTitle>
          <Text small={true}>{complaint.reason}</Text>
        </div>
        <div />
        {complaint.demandType === "Reclamos" && (
          <div>
            <SectionTitle light={true}>MONTO</SectionTitle>
            <Text small={true}>
              {complaint.amount
                ? `$${formatNumber(complaint.amount)} ${complaint.currency}`
                : ""}
            </Text>
          </div>
        )}
      </div>
      <div className="complaint-details">
        <SectionTitle light={true}>DETALLE DEL CASO</SectionTitle>
        <Text small={true}>{complaint.details}</Text>
      </div>
      {complaint.demandType === "Reclamos" && (
        <div className="complaint-request">
          <SectionTitle light={true}>PEDIDO</SectionTitle>
          <Text small={true}>{complaint.request}</Text>
        </div>
      )}
      <div className="complaint-request-documents">
        <SectionTitle light={true}>DOCUMENTOS</SectionTitle>
        {complaint.files.map((document, index) => (
          <DocumentContainer
            key={index}
            className="download-icon"
            onClick={() => {
              handleDownload(document);
            }}
          >
            <div className="document-name">
              <img src={PDFIcon} alt={"Exportar a PDF"} />
              <p>{document.slice(document.lastIndexOf("/") + 1)} </p>
            </div>
            <img src={downloadIcon} alt="Descargar" />
          </DocumentContainer>
        ))}
      </div>
    </Container>
  );
}

export default AdminComplaintsDetailComplaint;

function generateDownloadUrl(id) {
  const url = `${
    API.COMPLAINTS.URL
  }/presigned/download?object_name=${encodeURIComponent(id)}`;
  return fetch(url, {
    method: HTTP_METHODS.GET,
    headers: {
      accept: "*/*",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.ok) return response;
      throw response;
    })
    .then((response) => response.json())
    .then((response) => response.message.url)
    .catch((eResponse) => {
      // TODO: The server may return an error object,
      // and is converted using .json. Review this later
      return eResponse.json().then((data) => {
        const error = { ...data, status: eResponse.status };
        throw error;
      });
    });
}
